import {
  GET_ALL,
  GET_DETAIL,
  CREATE,
  DELETE,
  UPDATE,
  DELETE_SKU,
  UPDATE_SKU,
  CREATE_SKU,
  CREATE_SKU_FILE,
  SORTABLE,
  SORTABLE_SKU,
  GET_INTEGRATION,
  GET_BUSINESSES,
  GET_PRODUCT_TYPES,
  DEACTIVATE_PRODUCT,
  GET_PRODUCT_SKU_FILE_SUB_TYPES,
  UPDATE_SKU_FILES,
  CREATE_SKU_IDENTIFIER,
  REMOVE_SKU_IDENTIFIER,
  UPDATE_SKU_IDENTIFIER,
  GET_PRODUCT_PACK_TYPE,
} from '../types/product';

export function requestProductList(params) {
  return { type: GET_ALL, params };
}

export function requestProductDetail({ id }, payload) {
  return { type: GET_DETAIL, id, ...payload };
}

export function requestDeleteProduct(id, callback = null) {
  return { type: DELETE, id, callback };
}

export function requestUpdateProduct(payload, callback = null) {
  return { type: UPDATE, payload, callback };
}

export function getProductPackType() {
  return { type: GET_PRODUCT_PACK_TYPE };
}

export function sortableProduct(payload) {
  return { type: SORTABLE, payload };
}

export function requestDeleteSku(payload, callback) {
  return { type: DELETE_SKU, payload, callback };
}

export function deactivateProduct(id, callback) {
  return { type: DEACTIVATE_PRODUCT, payload: id, callback };
}

export function requestUpdateSku(payload, callback) {
  return { type: UPDATE_SKU, payload, callback };
}

export function updateSkuFiles(payload, callback) {
  return { type: UPDATE_SKU_FILES, payload, callback };
}

export function requestCreateSkuFile(payload) {
  return { type: CREATE_SKU_FILE, payload };
}

export function createProductSkuIdentifier(payload) {
  return { type: CREATE_SKU_IDENTIFIER, payload };
}

export function updateProductSkuIdentifier(payload) {
  return { type: UPDATE_SKU_IDENTIFIER, payload };
}

export function removeProductSkuIdentifier(payload) {
  return { type: REMOVE_SKU_IDENTIFIER, payload };
}

export function requestCreateProduct(payload, callback = null) {
  return { type: CREATE, payload, callback };
}

export function requestCreateSku(payload, callback = () => {}) {
  return { type: CREATE_SKU, payload, callback };
}

export function requestSortSku(payload, callback) {
  return { type: SORTABLE_SKU, payload, callback };
}

export function requestIntegration(params) {
  return { type: GET_INTEGRATION, params };
}

export function requestBusinesses(params) {
  return { type: GET_BUSINESSES, params };
}

export function getProductTypes() {
  return { type: GET_PRODUCT_TYPES };
}

export function getProductSkuFileSubTypes() {
  return { type: GET_PRODUCT_SKU_FILE_SUB_TYPES };
}
